import SeoLandingLayout from './components/SeoLandingLayout';

export default function DietistaPalmaPage() {
  return (
    <SeoLandingLayout
      title="Dietista en Palma de Mallorca | Dario Rojas"
      description="Dietista en Palma de Mallorca para reeducacion alimentaria, control de peso y planes personalizados adaptados a tu rutina."
      canonicalPath="/dietista-palma-de-mallorca"
      heading="Dietista en Palma de Mallorca"
      intro="Como dietista en Palma de Mallorca, te ayudo a mejorar tu relacion con la comida con pautas simples, flexibles y adaptadas a tus objetivos."
      bullets={[
        'Reeducacion alimentaria sin dietas extremas',
        'Plan de comidas ajustado a horarios y preferencias',
        'Apoyo para mejorar digestion y energia diaria',
        'Seguimiento para consolidar habitos saludables',
      ]}
      sections={[
        {
          title: 'Reeducacion alimentaria en Palma',
          paragraphs: [
            'Como dietista en Palma de Mallorca, te ayudo a construir una base de alimentacion equilibrada que puedas mantener a largo plazo.',
            'El objetivo es que entiendas como comer mejor segun tu contexto, sin reglas extremas y con pautas practicas para el dia a dia.',
          ],
        },
      ]}
      faqItems={[
        {
          question: 'En que se diferencia un dietista de un plan generico de internet?',
          answer:
            'La diferencia esta en la personalizacion. El plan se adapta a tus objetivos, tu historial y tu realidad diaria.',
        },
        {
          question: 'Trabajas con personas que quieren mejorar digestion y energia?',
          answer:
            'Si, es una de las consultas mas frecuentes en consulta de dietetica personalizada.',
        },
      ]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'Person',
        name: 'Dario Rojas',
        jobTitle: 'Dietista y Nutricionista',
        url: 'https://dariorojasnutricion.es/dietista-palma-de-mallorca',
        email: 'dariorojasnutricion@gmail.com',
        telephone: '+34 685546738',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Palma de Mallorca',
          addressCountry: 'ES',
        },
      }}
    />
  );
}
